import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button } from 'seagull';
import styles from './PresetButton.module.scss';
const PresetButton = (param)=>{
    let { onClick, disabled, testId, text } = param;
    return /*#__PURE__*/ _jsx(Button, {
        skin: "primaryOutline",
        onClick: onClick,
        disabled: disabled,
        testId: testId,
        className: styles.presetButton,
        children: text.charAt(0).toUpperCase() + text.slice(1)
    });
};
export default PresetButton;
